import React from 'react';
import { useSelector } from 'react-redux';

import Item from '../components/Item';

const WidgetContainer = () => {
	// Icon paths for reference:
	// ---------------
	// /static/assets/icons/spot/shield-check.svg
	// /static/assets/icons/spot/hands-heart.svg
	// /static/assets/icons/spot/award.svg
	// /static/assets/icons/spot/circle-check.svg <-- temp for return policy

	// TODO:
	// Make this data dynamically generated by the store
	// this should be set in state

	const { items } = useSelector((state) => state);
	const ifItemsExists = Object.keys(items).length > 0;

	return (
		<div className="d-flex flex-wrap">
			{ifItemsExists &&
				items.map(({ name, ...itemProps }) => (
					<Item key={name} {...itemProps} />
				))}
		</div>
	);
};

WidgetContainer.propTypes = {};

export default WidgetContainer;
